import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from 'react-oidc-context';

const Container = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    background-color: #cf9be8;
    padding: 0.25rem 0.5rem;
`;

const HorizontalList = styled.ul`
    padding: 1rem;
`;

const StyledLink = styled(Link)`
    margin-right: 5px;
    border-radius: 5px;
    padding: 1rem;
    background-color: #b895c9;
    color: #000000;
    text-align: center;
    text-decoration: none;

    :hover {
        color: #ffffff;
        background-color: #a456ca;
    }
`;

const StyledButton = styled.button`
    margin-right: 5px;
    border-radius: 5px;
    padding: 1rem;
    background-color: #e57373;
    color: #000000;
    text-align: center;
    text-decoration: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
    font-size: 1.1em;
    font-weight: bold;
    display: inline-block;

    :hover {
        color: #ffffff;
        background-color: #c62828;
    }

    :disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

type HeaderProps = {
    isAuthenticated: boolean;
};

const Header: React.FC<HeaderProps> = ({ isAuthenticated }) => {
    const auth = useAuth();

    const handleLogout = () => {
        auth.removeUser();
    };

    return (
        <Container data-testid="app-header">
            <HorizontalList>
                <StyledLink to="/">Home</StyledLink>
                {isAuthenticated && (
                    <>
                        <StyledLink to="/learn-react">Learn React</StyledLink>
                        <StyledLink to="/study-japanese">Study Japanese</StyledLink>
                        <StyledLink to="/showcase">Component Showcase</StyledLink>
                        <StyledLink to="/pachinko">🎯 Pachinko</StyledLink>
                        <StyledLink to="/balloon-release">🎈 Balloons</StyledLink>
                    </>
                )}
            </HorizontalList>
            <StyledButton type="button" onClick={handleLogout}>
                Logout
            </StyledButton>
        </Container>
    );
};

export default Header;
